import React from "react";
import Donation from "../../Images/donationImage.svg";
export default function DonationImage() {
  return (
    <div style={{ padding: "20px 10% 0 10%" }}>
      <img src={Donation} alt="donation" />
    </div>
  );
}
